/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'inc': {
    width: 46,
    height: 16,
    viewBox: '0 0 46 16',
    data: '<g _fill="#C8C7C4" fill-rule="nonzero"><path pid="0" d="M0 3.665h2.025v8.567H0v3.393h10.837v-3.393H8.79V3.665h2.047V0H0zM27.52 12.232V7.73c0-2.87-2.088-3.917-4.677-3.917-1.838 0-3.237.503-4.448 1.906a2.3 2.3 0 01-.313.335V3.686H11.4v3.415h1.525v5.131H11.4v3.414h8.478v-3.414H18.27V9.28c0-1.257.94-2.178 2.192-2.178.982 0 1.754.481 1.754 1.55v3.56H20.65v3.414h8.29v-3.351c0-.02-.021-.042-.021-.063h-1.4v.021z"/><path pid="1" d="M42.428 11.227h-4.552c0 1.256-.918 1.843-1.942 1.843-1.962 0-2.13-1.655-2.13-3.226v-.042c0-1.57.147-3.225 2.13-3.225 1.546 0 1.817 1.34 1.859 2.618l4.573-.503c-.48-4.67-5.074-4.964-6.223-4.964h-.25c-3.78 0-7.496 1.864-7.496 6.095 0 .901.167 1.697.48 2.388h.02v.063c1.128 2.513 4.052 3.645 6.996 3.645 2.4 0 5.763-.587 6.514-4.294l.021-.398z"/><ellipse pid="2" cx="43.994" cy="13.761" rx="1.921" ry="1.927"/></g>'
  }
})
